import React from 'react'
import { CustomScrollBoxSCN } from './CustomScrollBoxSCN'
import { UserDisplayerSCN } from './UserDisplayerSCN'
import { X } from 'lucide-react'
import { Button } from 'ui/components/button'
import { Separator } from 'ui/components/separator'
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'ui/components/tooltip'

export const UserListEditableSCN = <
  T extends {
    profilePhoto?: string | null | undefined
    id: number
    firstName: string
    lastName: string
    email: string
  },
>({
  withRemove = true,
  ...props
}: {
  users: T[]
  remove: (index: number, userId: number) => void
  withRemove?: boolean
  isLoading?: boolean
}) => {
  return (
    <>
      {props.users?.length > 0 && (
        <CustomScrollBoxSCN
          props={{
            onWheel: (e) => {
              e.stopPropagation()
            },
          }}
        >
          <div className='flex flex-col gap-2 mt-2'>
            {props.users?.map((user, index) => {
              return (
                <div key={index}>
                  <div className='flex w-full flex-row justify-between items-center'>
                    <UserDisplayerSCN user={user as any} />
                    {withRemove && (
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger>
                            <Button
                              size='xs'
                              type='button'
                              variant={'ghost'}
                              disabled={props.isLoading}
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                props.remove(index, user.id)
                              }}
                            >
                              <X className='w-4 h-4' />
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent side='left'>
                            Remover usuario
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    )}
                  </div>
                  {index + 1 !== props.users.length && (
                    <Separator className='mt-2' />
                  )}
                </div>
              )
            })}
          </div>
        </CustomScrollBoxSCN>
      )}
    </>
  )
}
